import * as React from "react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { DataGrid } from "@mui/x-data-grid";
import { Modal, Switch, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Box } from "@mui/system";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import { breadcrumbsActions } from "@store/breadcrumbs";
import { getAllFlashSales } from "@store/flash-sale-management";
import { setLoading } from "@store/asset-loader";
import { showErrorMessage, showSuccessMessage } from "@store/dashboard";
import ApplicationPageTemplate from "../../../dashboard/components/ApplicationPageTemplate/ApplicationPageTemplate";
import { CountryList } from "../../../../components/CountryList";
import AddFlashSale from "./addFlashSale";
import styled from "styled-components";
import { addFlashSale, deleteFlashSale , updateFlashSale } from "@store/flash-sale-management";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		overflow: "scroll",
	},
	modalContent: {
		position: "absolute",
		top: "50%",
		left: "50%",
		transform: "translate(-50%, -50%)",
		backgroundColor: "#fff",
		padding: 16,
		width: "50%",
		overflow: "scroll",
	},
	modalTitle: {
		marginBottom: 10,
	},
	formLabel: {
		display: "in-line",
		marginBottom: 5,
		fontWeight: "bold",
	},
	formInput: {
		width: "100%",
		marginBottom: 10,
		padding: 8,
		border: "1px solid #ccc",
		borderRadius: 4,
		boxSizing: "border-box",
	},
	formCheckbox: {
		marginRight: 8,
	},
	formActions: {
		display: "flex",
		justifyContent: "flex-end",
		marginTop: 10,
	},
}));

const FilterActionContainer = styled.div`
	padding: 16px 16px 0 16px;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
`;

const FilterContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const OptionContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
`;

const TitleCell = styled.div`
	min-width: 100%;
	flex: 1;
	font-weight: 500;
`;

const ActionButtons = styled.div`
	display: flex;
	flex-direction: column;
	flex-wrap: nowrap;
	align-items: flex-start;
	padding: 8px 0;
	gap: 10px;
`;

const FlashSale = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const classes = useStyles();
	const flashSaleList = useSelector((state) => state.flashSaleList.flashSaleList);
	const labels = useSelector((state) => state.flashSaleList.labels);
	const [rowsDataGrid, setRowsDataGrid] = useState([]);
	const [modalOpen, setModalOpen] = useState(false);
	const [selectedImageUrl, setSelectedImageUrl] = useState("");
	const [defaultCountry, setDefaultCountry] = useState("my");
	const [openModal, setOpenModal] = useState(false);
	// const [openModalUpdate, setOpenModalUpdate] = useState(false);
	const [existingFormData, setExistingFormData] = useState(null);
	const showDeleted = false;

	const handleCloseModal = () => {
		setSelectedImageUrl("");
		setModalOpen(false);
	};

	useEffect(() => {
		dispatch(
			breadcrumbsActions.setBreadcrumbs([
				{ label: "Home", url: "/" },
				{ label: "Flash Sale Management", url: "/flash-sale-management" },
			])
		);
		dispatch(getAllFlashSales({ inactive: showDeleted }));
	}, [dispatch, showDeleted]);

	useEffect(() => {
		if (flashSaleList) {
			setRowsDataGrid([...flashSaleList]);
		}
	}, [flashSaleList]);

	//onchange filter by flash sale title
	const columns = [
		{
			field: "Id",
			headerName: "Id",
			width: 220,
			renderCell: (params) => (
				<div>
					<TitleCell>{params.id}</TitleCell>
				</div>
			),
		},
		{
			field: "title",
			headerName: "Title",
			width: 300,
			renderCell: (params) => (
				<div>
					<TitleCell>{params.value}</TitleCell>
				</div>
			),
		},
		{ field: "country", headerName: "Country", width: 80 },
		{ field: "startDateTime", headerName: "Start DateTime", width: 200, renderCell: (params) =>  moment(new Date(params.value), '').format() },
		{ field: "endDateTime", headerName: "End DateTime", width: 200, renderCell: (params) => moment(new Date(params.value), '').format() },
		{ field: "startsIn", headerName: "Starts-In", width: 200, renderCell: (params) => moment(new Date(params.value), '').format() },
		{
			field: "isDeleted",
			headerAlign: "center",
			headerName: "Active/Inactive",
			width: 120,
			renderCell: (params) => <Switch checked={!params.value} onChange={(event) => handleIsDeletedChange(params.row, event.target.checked)} key={params.id} />,
		},
		{
			field: "actions",
			headerAlign: "center",
			headerName: "Actions",
			width: 250,
			renderCell: (params) => (
				<ActionButtons>
					{
						<Button
							variant="outlined"
							color="primary"
							size="small"
							startIcon={<ModeEditIcon size="small" />}
							onClick={() => {
								navigate(`/flash-sale-management/add-product/${params.row.id}`);
							}}
						>
							Add Products
						</Button>
					}
					{
						<Button
							variant="outlined"
							color="primary"
							size="small"
							// startIcon={<ModeEditIcon size="small" />}
							onClick={() => {
								// save changes for this row
								const updatedRowData = { ...params.row };
								console.log("updatedRowData:", updatedRowData)
								setExistingFormData(updatedRowData);
								setOpenModal(true);
							}}
						>
							Update
						</Button>
					}
				</ActionButtons>
			),
		},
	];
	//Add modal
	const handleOpenModaladd = () => {
		setOpenModal(true);
	};
	const handleCloseModaladd = () => {
		setExistingFormData(null);
		setOpenModal(false);
	};

	const handlSelectChange = (country) => {
		if (!country) return;
		setDefaultCountry(country);
		dispatch(getAllFlashSales({ id: country }));
	};

	const inputProps = {
		required: true,
		fullWidth: true,
		width: "250px",
		margin: "normal",
		onChange: handlSelectChange,
	};
	const formatSubErrors = (subErrors) => `Error while trying to add a new Product:\n${subErrors.map((item) => `${item.field}: ${item.message}`).join("\n")}`;

	const handleAddNew = (data) => {

		console.log("data to be update", data);
		dispatch(setLoading(true));
		// Update Existing Flash Sale
		if (!!data.id) {
			dispatch(updateFlashSale({ ...data }))
				.then((response) => {
					dispatch(setLoading(false));
					if (response.payload.status !== "BAD_REQUEST") {
						return dispatch(showSuccessMessage("Flash Sale Updated Successfully"));
					} else {
						if (response.payload.subErrors !== null) {
							return dispatch(showErrorMessage(formatSubErrors(response.payload.subErrors)));
						} else {
							return dispatch(showErrorMessage("error While Trying to add new Product.PLease check with Tech"));
						}
					}
				})
				.catch(function (error) {
					console.log(error);
					dispatch(setLoading(false));
					dispatch(showErrorMessage(`Failed to update Product: ${error}`));
				});
		} else {
			// Add new Flash Sale
			dispatch(addFlashSale({ ...data }))
				.then((response) => {
					dispatch(setLoading(false));
					if (response.payload.status !== "BAD_REQUEST") {
						return dispatch(showSuccessMessage("Flash Sale Added Successfully"));
					} else {
						let errorSummary = "";
						if (response.payload.subErrors !== null) {
							errorSummary = formatSubErrors(response.payload.subErrors);
							return dispatch(showErrorMessage(errorSummary));
						} else {
							return dispatch(showErrorMessage("error While Trying to add new Product.PLease check with Tech"));
						}
					}
				})
				.catch((error) => {
					dispatch(setLoading(false));
					dispatch(showErrorMessage(`Failed to add Product: ${error}`));
				});
		}
	};

	const handleIsDeletedChange = (data, checked) => {
		dispatch(setLoading(true));

		dispatch(deleteFlashSale({ flashSaleId: data.id }))
			.then(() => {
				dispatch(setLoading(false));
				return dispatch(showSuccessMessage("Product updated successfully"));
			})
			.catch(function (error) {
				console.log(error);
				dispatch(showErrorMessage(`Failed to update Product: ${error}`));
			});
	};

	return (
		<ApplicationPageTemplate title={"Flash Sale Management"} description={"Manage Flash Sale with Add & Update"} pageReady={true}>
			<div style={{ height: 800, width: "100%" }}>
				<FilterActionContainer>
					<FilterContainer>
						<CountryList {...inputProps} onChange={handlSelectChange} placeholder="Select Country" id="country" value={defaultCountry != null ? defaultCountry : "my"} background="white" compactView />
						<OptionContainer>
						</OptionContainer>
					</FilterContainer>
					<div>
						<Button variant="contained" color="primary" onClick={handleOpenModaladd} size="large" startIcon={<ControlPointIcon size="large" />} disableElevation>
							Add New Flash Sale
						</Button>
					</div>
				</FilterActionContainer>
				{<DataGrid getRowHeight={() => "auto"} sx={{ m: 2 }} groupBy={"country"} rows={rowsDataGrid} rowClassName="fixed-height-cell" rowHeight={90} columns={columns} pageSize={50} />}
				<AddFlashSale isVisible={openModal} onClose={handleCloseModaladd} onCreate={handleAddNew} existingFormData={existingFormData} labels={labels} country={defaultCountry != null ? defaultCountry : "my"} />
				{/* <UpdateFlashSale isVisible={openModalUpdate} onClose={handleCloseModalUpdate} onCreate={handleAddNew} existingFormData={existingFormData} labels={labels} country={defaultCountry != null ? defaultCountry : "my"} /> */}
				<Modal className={classes.modal} open={modalOpen} onClose={handleCloseModal}>
					<Box sx={{ width: 300 }}>
						<img src={selectedImageUrl} alt="" style={{ maxHeight: "50%", maxWidth: "100%" }} />
					</Box>
				</Modal>
			</div>
		</ApplicationPageTemplate>
	);
};

export default FlashSale;
